export default [
  {
    path: "search-nofly",
    name: "search-nofly",
    meta: { text: "noFly" },
    component: () => import("@/views/nofly/SearchNoFly.vue"),
  },
  {
    path: "search-nofly/:noFlyId",
    name: "nofly-detail",
    meta: { text: "noFly" },
    component: () => import("@/views/nofly/NoFlyDetail.vue"),
  },
];
